var render, staticRenderFns
import script from "./MapChart.vue?vue&type=script&lang=js&"
export * from "./MapChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5216605f",
  null
  
)

export default component.exports